import React, { useMemo } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { Manufacturer } from '../../schemas/crm';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex?: number;
    disabled?: boolean;
    includeAllOptions?: boolean;
    labelFontSize?: number;
    required: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value?: Manufacturer;
    setValue: React.Dispatch<React.SetStateAction<Manufacturer | undefined>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function CameraManufacturerDropdown({ value, setValue, zIndex, disabled, includeAllOptions, labelFontSize, required, fieldName, form }: Props) {
    const items = useMemo(() => {
        const options = [
            'hikvision',
            'dahua',
            'intelbras'
        ];

        if (includeAllOptions) {
            options.unshift('all');
        }

        return options.map(type => ({ label: translate(type), value: type }));
    }, [includeAllOptions]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('manufacturer')}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('manufacturer')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value ?? ''}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    }
}

export default CameraManufacturerDropdown;
